// @flow
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {EdapProvider} from '@homeaway/react-event-tracking';
import Experiment, {On} from '@homeaway/react-experiment';

import FlexibleDates from './FlexibleDates';
import {media} from '../../utils/breakpoints';
import routerActions from '../../actions/router';
import {VRBO_WEB_FLEX_DATE_A_INSIGHT} from '../../abacus/experiments';

import type {State as ReduxState} from '../../reducers/index';
import type {PercentBookedResult} from '../../queries/searchRequestQuery';

type StateProps = {
    startDate?: string,
    endDate?: string,
    locale: string,
    isDesktop: boolean,
    previousSearchTerm?: string,
    searchTerm?: string
};

type OwnProps = {
    loading: boolean,
    resultCount?: number,
    percentBooked?: PercentBookedResult
};

type DispatchProps = {
    search: typeof routerActions.search
};

type Props = StateProps & DispatchProps & OwnProps;

export function FlexibleDatesContainer({
    search,
    previousSearchTerm,
    searchTerm,
    percentBooked,
    resultCount,
    ...props
}: Props) {
    const [
        isSubsequentFlexOptions,
        setIsSubsequentFlexOptions
    ] = useState<boolean>(false);

    useEffect(() => {
        if (previousSearchTerm !== searchTerm) {
            setIsSubsequentFlexOptions(false);
        }
    }, [previousSearchTerm, searchTerm]);

    function onDateChange(arrival: string, departure: string) {
        search({arrival, departure});
        setIsSubsequentFlexOptions(true);
    }

    const defaultFields = {
        eventcategory: 'flexible dates'
    };

    const showFlexibleDates = () => {
        return !!(
            isSubsequentFlexOptions ||
            (resultCount &&
                resultCount !== 0 &&
                resultCount <= 50 &&
                percentBooked &&
                percentBooked.currentPercentBooked &&
                percentBooked.currentPercentBooked >= 0.5)
        );
    };

    return (
        showFlexibleDates() && (
            <Experiment name={VRBO_WEB_FLEX_DATE_A_INSIGHT}>
                <On>
                    <EdapProvider fields={defaultFields}>
                        <FlexibleDates
                            resultCount={resultCount}
                            {...props}
                            onDateChange={onDateChange}
                        />
                    </EdapProvider>
                </On>
            </Experiment>
        )
    );
}

const mapStateToProps = ({
    searchParams: {
        params: {arrival, departure, q: searchTerm},
        prevParams: {q: previousSearchTerm}
    },
    system: {locale},
    viewport: {breakpoint}
}: ReduxState): StateProps => {
    return {
        startDate: arrival,
        endDate: departure,
        locale,
        isDesktop: media(breakpoint, {
            minWidth: 'SM_MIN'
        }),
        previousSearchTerm,
        searchTerm
    };
};

const mapDispatchToProps = {
    search: routerActions.search
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FlexibleDatesContainer);
